import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Does it really stick to any surface?',
  answer: 'The LumiMate features industrial-grade suction cups that work best on smooth, non-porous surfaces like glass, mirrors, polished wood, plastic, and metal. Make sure the surface is clean for the strongest "hero-grip"!'
}, {
  question: 'What kind of batteries does it use?',
  answer: "It is powered by 3x LR41 button cell batteries (which are included with your order). They are long-lasting and very easy to replace—just pop off the back of the head, and you're good to go."
}, {
  question: 'Is the light too bright for a nightlight?',
  answer: 'Not at all. We designed it with a "Warm-Glow" LED (2700K). It provides enough light to read or find your way in the dark, but it\'s soft enough to keep a cozy, relaxing atmosphere without straining your eyes.'
}, {
  question: 'How flexible are the limbs? Can they break?',
  answer: 'The limbs are built with a high-tension internal skeleton designed to be bent and twisted thousands of times. While it\'s not a "toy" for rough play, it is highly durable and holds its pose perfectly.'
}, {
  question: 'How long will it take to receive my LumiMate?',
  answer: 'Orders are processed within 24-48 hours. Depending on your location, standard shipping usually takes 7-12 business days. You will receive a tracking number as soon as it ships!'
}, {
  question: "What if I'm not happy with it?",
  answer: "We love our LumiMate, and we're sure you will too. But if for any reason you aren't satisfied, we offer a 30-Day Money-Back Guarantee. No stress, no questions asked."
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (idx: number) => {
    setOpenIndex(prev => prev === idx ? null : idx);
  };
  return <section className="py-12" data-id="element-31">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl font-bold text-center text-white mb-10" data-id="element-32">
        Frequently Asked Questions
      </motion.h2>

      <div className="flex flex-col gap-3" data-id="element-33">
        {faqs.map((faq, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.05
      }} className="bg-brand-card border border-white/5 rounded-xl overflow-hidden" data-id="element-34">
            <button onClick={() => toggle(idx)} className="w-full flex items-center justify-between p-5 text-left gap-4 hover:bg-white/5 transition-colors" data-id="element-35">
              <span className="text-white font-semibold text-base" data-id="element-36">
                {faq.question}
              </span>
              <motion.div animate={{
            rotate: openIndex === idx ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="shrink-0" data-id="element-37">
                <ChevronDownIcon className="w-5 h-5 text-brand-orange" data-id="element-38" />
              </motion.div>
            </button>

            <AnimatePresence initial={false} data-id="element-39">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-40">
                  <div className="px-5 pb-5 text-brand-muted leading-relaxed border-t border-white/5 pt-4" data-id="element-41">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}